import { feSetClientProfileBookingsCounts, feSetClientProfileData } from 'actions/client/clientProfile.action';
import { feSidebarClose, feSidebarOpen } from 'actions/ui.actions';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import { isValidId } from 'utils/predicates/fields.util';

const L = logger('clientProfileSidebarReducer');

const reduceOpen = (state, action) => {
  const clientId = action?.data?.clientId;

  if (!isValidId(clientId)) {
    L.warn('()', action?.ATAG, 'Invalid clientId:', clientId);
    return state;
  }

  return {
    ...state,
    clientId,
    open: true,
    bookingsCounts: null,
    clientData: null,
  };
};

const reduceClose = (state) => ({
  ...state,
  clientId: null,
  open: false,
  bookingsCounts: null,
  clientData: null,
});

const reduceSetBookingsCounts = (state, action) => {
  const { pastCount, futureCount } = action?.data ?? {};
  const current = state?.bookingsCounts ?? {};

  return {
    ...state,
    bookingsCounts: {
      past: fromAnyToNumber(pastCount) || current.past,
      future: fromAnyToNumber(futureCount) || current.future,
    },
  };
};

const reduceSetClientProfileData = (state, action) => {
  const clientData = action?.data ?? null;

  return {
    ...state,
    clientData,
  };
};

const MAP = Object.freeze({
  [feSidebarOpen.AT.name]: reduceOpen,
  [feSidebarClose.AT.name]: reduceClose,
  [feSetClientProfileBookingsCounts.AT.name]: reduceSetBookingsCounts,
  [feSetClientProfileData.AT.name]: reduceSetClientProfileData,
});

const clientProfileSidebarReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? {}, action ?? {});

// noinspection JSUnusedGlobalSymbols
export default clientProfileSidebarReducer;
